package io.eqoty.secretk.wallet

enum class Algo {
    secp256k1,
    ed25519,
    sr25519
}